import { produce } from 'immer';

import initialState from './initialState';

const actions: any = {
  setClear: (): UseUserReducerStateType => initialState,

  setProfile: (
    state: UseUserReducerStateType,
    params: UseUserSetProfileProps,
  ): UseUserReducerStateType => ({
    ...state,
    ...params,
  }),
};

function reducer(
  state: UseUserReducerStateType,
  action: ReducerGenericActionsType,
): UseUserReducerStateType {
  return produce(state, (draftState: UseUserReducerStateType) =>
    action.type ? actions[action.type](draftState, action.params) : draftState,
  );
}

export { actions, reducer };
